// extracted by mini-css-extract-plugin
export default {"colours":"Colours_colours__MDLEf","container":"Colours_container__Qu-cF","boxBorderCircle":"Colours_boxBorderCircle__oeSsV","circle":"Colours_circle__msTTY"};